import React from 'react';

import { Route, Switch } from 'react-router-dom/cjs/react-router-dom.min';

import SchedulesActive from '../../components/ActiveUserDashboard/SchedulesActive';
import TimelineByUser from '../../components/ActiveUserDashboard/TimelineByUser';
import { PATHS } from '../../constants';

interface ActiveUserDashboardRoutesProps {
  url: string;
}

const ActiveUserDashboardRoutes: React.FC<ActiveUserDashboardRoutesProps> = ({ url }) => (
  <Switch>
    <Route path={`${url}/${PATHS.ACTIVE_USER_DASHBOARD_TIMELINE}`} component={TimelineByUser} />
    <Route path={`${url}/${PATHS.ACTIVE_USER_DASHBOARD_SCHEDULES}`} component={SchedulesActive} />
  </Switch>
);

export default ActiveUserDashboardRoutes;
